// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkmark:after,.checkmark:before{content:\" \";position:absolute;background:#fff;height:2px;top:50%;left:0;transform-origin:left bottom}.checkmark:before{width:10px;transform:translate(12px,3px) rotate(-45deg)}.checkmark:after{width:7px;transform:translate(12px,3px) rotate(-135deg)}.rotate{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
